<script setup lang="ts">
import { watch } from 'vue'
import LargeDialog from './LargeDialog.vue'
import type { SceneInfo } from '~/types/interfaces'

interface PurchasableScene extends SceneInfo {
  priceId: string
}

const emit = defineEmits(['clickScene', 'clickBack'])

const dialogStore = useDialogStore()
const dialog = dialogStore.broker

const paymentDialog = ref<boolean>(false)
const { reloadGameState } = useGameStateStore()
const { triggerEventAndProcess } = useEventSystem()
const { $music } = useNuxtApp()

const sceneToPurchase = ref<PurchasableScene | null>(null)
const timerId = ref<NodeJS.Timeout | null>(null)

const onClickBack = () => {
  dialogStore.closeDialog('broker', 'cancel')
  emit('clickBack')
  // console.log("AdventurerCamp.onClickBack")
  // return navigateTo('/adventurerscamp')
}

watch(() => dialog.visible, (newVal, oldVal) => {
  console.log('dialog.visible changed from', oldVal, 'to', newVal)

  if (newVal) {
    triggerEventAndProcess('cmp_fairyBroker.enter')
    $music.pushMusic('cmp_fairyBroker')
  }
  else {
    $music.popMusic()
    triggerEventAndProcess('cmp_fairyBroker.exit')
  }
})

onMounted(() => {
  if (process.env.NODE_ENV !== 'development') {
    timerId.value = setInterval(() => {
      reloadGameState()
    }, 5000)
  }
  else {
    console.log('Debugging mode: Timer disabled')
  }
})

onBeforeUnmount(() => {
  if (timerId.value) {
    clearInterval(timerId.value)
  }
})
</script>

<template>
  <LargeDialog
    v-if="dialog.params"
    :title="dialog.params.title || '妖精との仲介者'"
    :model-value="dialog.visible"
    :cancel-button="{ title: 'とじる' }"
    @cancel="onClickBack"
  >
    <template #default>
      <v-img
        src="@/assets/images/FairyBrokerDialog.webp"
        width="100%"
        height="auto"
        :transition="false"
      />
      <EmporiumPurchaseDialog
        v-model="paymentDialog"
        :title="sceneToPurchase?.name || ''"
        :price-id="sceneToPurchase?.priceId!"
        :scene-id="sceneToPurchase?.sceneId!"
      />
    </template>
  </LargeDialog>
</template>

<style scoped>
.list-of-areas {
  font-family: Utsukushi;
  position: absolute;

  top: 50%;
  left: 50%;

  translate: -50% -50%;
  width: 80%;

  background-color: rgb(128, 64, 64, 0.5);
}

.list-of-areas-table {
  font-size: 1.3rem;
  background-color: rgb(255, 255, 255, 0.7);
}

.list-of-areas-table th {
  background-color: rgb(255, 255, 255, 0.8) !important;
}
</style>
